const fonts = {
  heading: "'PolySans Trial', sans-serif",
  // heading: "'PolySans Bulky Wide', sans-serif",
  body: "'Neue Haas Grotesk Display Pro', sans-serif",
  mono: "'Quicksand', sans-serif",
};

export default fonts;
